import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const gaana: MusicService = {
  id: 'gaana',
  name: 'Gaana',
  shortName: 'Gaana',
  isSupported: false,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: true,
  color: {
    primary: '#e72c30',
    label: '#E72C30',
    background: '#876c6c',
  },
  importerID: ImporterID.Gaana,
  musicAPIID: MusicAPIIntegrationID.Gaana,
  linkType: 'gaana',
  assets: {
    logo: { light: 'gaana-light.svg', dark: 'gaana-dark.svg' },
    logoPadding: { light: 'gaana-light-padding.svg', dark: 'gaana-dark-padding.svg' },
    logoColor: { light: 'gaana-color-light.svg', dark: 'gaana-color-dark.svg' },
    logoColorPadding: {
      light: 'gaana-color-light-padding.svg',
      dark: 'gaana-color-dark-padding.svg',
    },
    logoOnBackground: 'gaana-dark.svg',
  },
  whatIsDescription: musicServiceMessages.gaanaWhatIs,
};
